<template>
  <div
    class="bq-card-wrapper"
    ref="wrap"
    @mouseleave="handleMouseLeave"
    @mouseout="handleMouseOut"
  >
    <img :src="img" :alt="title" class="bq-card-img" />
    <div class="bq-card-dialog">
      <img
        :src="coverImg"
        alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
      />
    </div>

    <dl class="bq-card-content">
      <dt><img :src="icon" ref="icon" /></dt>
      <dd class="bq-card-title">{{ title }}</dd>
      <dd class="bq-desc">{{ desc }}</dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'MaskCard',

  props: {
    title: {
      required: true,
    },
    icon: {
      required: true,
    },
    img: {
      required: true,
    },
    coverImg: {
      required: true,
    },
    desc: {
      required: true,
    },
    num: {
      required: true,
    },
    index: {
      required: true,
    },
  },

  data() {
    return {
      isMobile: false,
      screenWidth: document.body.clientWidth,
    };
  },

  mounted() {
    // 1、数据首次加载完后 → 获取图片（或外层框）宽度，并设置其高度
    this.$nextTick(() => {
      this.renderSize();
    });
  },

  methods: {
    renderSize() {},
    handleMouseOut() {},
    handleMouseLeave() {
      this.renderSize();
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
